(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('ol-client-');
        $sessionStorageProvider.setKeyPrefix('ol-client-');
    }
})();
